import { encryptPassword } from "../../../../v2/Utils/Encryption/NodeForgeEncryption";
import { verifyOTPAction } from "../../../Auth/Register/API/Action";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify"; 
import { addMemberAction } from "../API/Action";
import OTPVerificationComponent from "../../../Common/OTPVerification/OTPVerificationComponent";
import { OTP_PURPOSE_ENUM } from "../../../Auth/Enum";
import { CustomButton } from "../../../../v2/MUI_custom_component";
import { useState } from "react";
import { EMPLOYEE_TYPES_ENUM } from "../Enum";

export const OTPValidation = ({
  mobileNumber,
  handleSendOTP,
  isLoading,
  error,
  formData,
  fetchEmployeeDetails,
  setShowStaffPermissionModal,
  onStaffOtpVerified,
  onCloseModal,
  onVerifySuccess,
  firmId,
  role,
  permissions = null,
  refreshFunction,
  setShowOTPComponent,
  showOTPComponent,
  onOwnerAddedRequiresWhatsapp,
}) => {
  const dispatch = useDispatch();
  
  const userId = useSelector((state) => state.loginReducer.loginUser?.user_id);
  const encryptedUserId = encryptPassword(String(userId));
  const [existingUserId, setExistingUserId] = useState(null);

  const onSendOTP = async (resend) => {
    const response = (await handleSendOTP(resend)) || {};
    const success =
      typeof response.success === "boolean"
        ? response.success
        : response.error === false;
    const message = response.message;
    if (success) {
      setShowOTPComponent(true);
      if (resend !== true) {
        toast.success(message || "OTP sent successfully");
      }
    } else setShowOTPComponent(false);
    return { success };
  };

  const handleVerifyOTP = async (otp) => {
    const payload = {
      mobile_number: encryptPassword(mobileNumber),
      otp: encryptPassword(otp),
      purpose: OTP_PURPOSE_ENUM.EMPLOYEE,
      user_id: encryptedUserId,
    };
    const { data, error, message } = await verifyOTPAction(payload);
    if (!error) {
      dispatch({ type: "SET_VFC_TOKEN", payload: data.vfc_token });
      if (data.existing_user_id) setExistingUserId(data.existing_user_id);
      return { success: true, data, message, vfc_token: data.vfc_token };
    } else {
      return { success: false, message };
    }
  };

  const handleAddMember = async (result) => {
    const memberPayload = {
      firm_id: firmId,
      staff_details: {
        id: existingUserId || null,
        name: formData.full_name || formData.name,
        dob: formData.dob || null,
        vfc_token: result.vfc_token,
        mobile: formData.phone_number || formData.mobileNumber,
        is_whatsapp_same: formData.isWhatsAppSame,
        role: role.value,
        permissions: permissions || null,
      },
    };
    if (role.value === EMPLOYEE_TYPES_ENUM.STAFF) {
      if (onStaffOtpVerified) {
        onStaffOtpVerified(memberPayload);
      }
      if (setShowStaffPermissionModal) {
        setShowStaffPermissionModal(true);
      }
      return { success: true };
    }
    const { data, message, error } = await addMemberAction(memberPayload);

    if (error) {
      toast.error(message || "Failed to add member");
      if (onCloseModal) {
        onCloseModal();
      }
      return { success: false, message };
    } else {
      if (
        role.value === EMPLOYEE_TYPES_ENUM.OWNER &&
        !formData.isWhatsAppSame
      ) {
        if (onOwnerAddedRequiresWhatsapp) {
          onOwnerAddedRequiresWhatsapp({ ownerId: data.id, firmId });
        }
        if (onCloseModal) {
          onCloseModal();
        }
        return { success: true, data, message };
      } else {
        await refreshFunction();
        toast.success(message || "Member added successfully");
        if (onCloseModal) {
          onCloseModal();
        }
      }
      if (onVerifySuccess) {
        onVerifySuccess();
      }
    }
  };

  return (
    <>
      {!showOTPComponent && (
        <CustomButton
          variant="text"
          color="primary"
          label="Send OTP"
          disabled={isLoading || error.name || error.mobileNumber}
          onClick={onSendOTP}
        />
      )}
      {showOTPComponent && (
        <OTPVerificationComponent
          onVerify={handleVerifyOTP}
          onResend={onSendOTP}
          purpose="verifyCurrentPhone"
          onError={(error) => {
            console.error("OTP verification error:", error);
          }}
          showText={false}
          onAnimationComplete={handleAddMember}
        />
      )}
    </>
  );
};
